module.exports = __webpack_public_path__ + "img/uranium-ore.b095d799.png";